<div class="layout-col full bg-background">
  <app-work-batch-detail class="flex" [batch]="batch" (batchAbortRequested)="close()">
  </app-work-batch-detail>
</div>
